import i18next from 'i18next'
import Backend from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

import { initReactI18next } from 'react-i18next'

// import store from "_src/store";

import translation_en_US from './en_US.json'
import translation_el_GR from './el_GR.json'
import translation_ms_MY from './ms_MY.json'
const resources = {
  en_US: {
    translation: translation_en_US,
  },
  el_GR: {
    translation: translation_el_GR,
  },
  ms_MY: {
    translation: translation_ms_MY,
  },
}

i18next
  .use(Backend) //嗅探当前浏览器语言
  // .use(Cache)
  .use(LanguageDetector)
  .use(initReactI18next) //init i18next
  .init({
    debug: false,
    resources,
    // lng: "en_US",
    fallbackLng: 'en_US', // 如果用户选择的语言不被支持，那么使用英文
    whitelist: ['en_US', 'el_GR', 'ms_MY'], // 支持的语言 英文和繁体
    // backend: {
    //   // 自动获取该文件夹下的json文件
    //   loadPath: "/locales/{{lng}}/{{ns}}.json",
    // },
    interpolation: {
      escapeValue: false,
    },
    react: {
      // wait: true,
      useSuspense: false,
    },
    // nonExplicitSupportedLngs: true,
    detection: {
      caches: ['localStorage'],
    },
  })

// i18next.on("initialized", function (options) {
//   console.log("initialized", options);
// });
// i18next.on("loaded", (loaded) => {
//   console.log("loaded", loaded);
// });

// i18next.on("languageChanged", (language) => {
//   console.log("languageChanged", language);
// });

// i18next.on("missingKey", (lngs, namespace, key, res) => {
//   console.log(key, res);
// });

export default i18next
